<template>
    <BaseModal
        :id="'static-copy-room'"
        :title="title"
        :message="''"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                  :form_format="form_format"
                  :form_data="form_data"
                  :array_options="array_options"
                  :for_update="false"
                />
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`Minutes To Copy: ${minutes_move} Min`"></label>
                </div>
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`New Assignment Current Total: ${form_data.daily_assignment_id ? new_current_total : 0} Min`"></label>
                </div>
                <div class="mt-3">
                    <label class="black-label" for="" v-html="`New Assignment Total After Copy: ${form_data.daily_assignment_id ? (minutes_move + new_current_total) : 0} Min`"></label>
                </div>
                <!-- <div v-if="total_minutes" class="mt-3">
                    <label class="black-label" for="" v-html="`This Assignment Total After Copy: ${total_after_move()} Min`"></label>
                </div> -->
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Confirm Copy`"/>
                </div>
            </form>
        </template>
    </BaseModal>
</template>

<style scoped>
    .black-label{
        color:black;
    }
</style>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'

export default {
  name: "FormModalCopy",
  props: [
    "title",
    "rest_api",
    "notyf",
    "array_options",
    "breadcrumb",
    "parent_id",
    "rooms",
    "total_minutes",
  ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    computed:{

        minutes_move()
        {
            return this.sumArrays(this.rooms.map(item => item.minutes), true)
        },

    },

    data(){
        return{
            form_data: FormResources.form_data_move,
            form_format: FormResources.form_format_copy,
            form_backup: {...FormResources.form_data_move},
            new_current_total: 0,
        }
    },

    watch: {

        rooms(val)
        {
            if(val)
            {
                this.form_data.rooms = val;
            }

        },

        'form_data.daily_assignment_id'(val)
        {
            if(val)
            {
                let minutes = this.array_options.daily_assignment_id.find(item => item.id == val).minutes
                this.new_current_total = this.sumArrays(minutes, true)
            }
        }

    },

    methods: {

        async form_submit() 
        {
            const json_request = {
                id: this.parent_id,
                requirement: 'copy_rooms',
            }

            this.loader(true)
            const response  = await this.patch(`${this.rest_api}/${JSON.stringify(json_request)}`, this.form_data)

            if(response.status)
            {
                this.$emit('copyRoom', true);
                this.loader()
                window.$('#static-copy-room').modal('hide')
                this.form_data = {...this.form_backup};
            }
            else
            {
                this.error_handling(response)
                this.loader()
            }
        },

        total_after_move()
        {
            return parseFloat(Number(this.total_minutes) - this.minutes_move).toFixed(2)
        },

    },

  mounted() {},

};
</script>